import React, { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../util/Utils";
import { useLocation } from "react-router-dom";

export function UseMyPC(sortColumn, sortOrder) {
  const location = useLocation();

  const [myPc, setMyPc] = useState(
    location.state && location.state.myPc
      ? location.state.myPc
      : {
          page: 0,
          sortColumn: sortColumn || sortColumn == "" ? sortColumn : "Id",
          sortOrder: sortOrder || sortOrder == "" ? sortOrder : "Asc",
          searchColumn: "",
          scrollTo: undefined,
          forceRefresh: false,
        }
  );

  const goToLastPage = (lastPage) => {
    setMyPc({ ...myPc, page: lastPage, scrollTo: undefined });
  };

  const goToFirstPage = () => {
    setMyPc({ ...myPc, page: 1 });
  };

  const updatePage = (page) => {
    setMyPc({ ...myPc, page: page, scrollTo: undefined });
  };

  const updateSort = (col, order) => {
    setMyPc({
      ...myPc,
      sortColumn: capitalizeFirstLetter(col),
      sortOrder: order,
      sorted: true,
    });
  };

  const setScrollTo = (value) => {
    myPc.scrollTo = value;
  };

  const refresh = () => {
    let page = myPc.page;
    if (page === 0) {
      page = 1;
    }
    setMyPc({ ...myPc, forceRefresh: !myPc.forceRefresh, page: page });
  };

  return {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  };
}
